module.exports = __webpack_public_path__ + "img/new-bg.ce206038.png";